import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Flex, FormControl, FormLabel, Heading, Input, InputGroup, Select, Stack, Text, useColorModeValue, useToast, Badge, IconButton } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStateContext } from '../../../context/ContextProvider';
import axiosClient from '../../../axios-client';
import Resizer from "react-image-file-resizer";
import { CloseIcon, AttachmentIcon } from '@chakra-ui/icons';

import { handlePriceChange, formatPriceForBackend } from "../../../utils/priceFormatter";

function UpgradeStock() {

    const { user, currentBusiness, setCurrentBusiness } = useStateContext()

    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const toast = useToast();
    const today = new Date().toISOString().split('T')[0];

    const [dataProperties, setDataProperties] = useState([
        { color: "", size: "", quantity: "", purchase_price: "", stock_weight: "", weight_unit: "kg", purchase_date: today, source: "", warehouse: "", receipts: [] },
    ]);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);

    //Message Error
    const [messageErrColor, setMessageErrColor] = useState('')
    const [messageErrSize, setMessageErrSize] = useState('')
    const [messageErrQuantity, setMessageErrQuantity] = useState('')
    const [messageErrPurchase_price, setMessageErrPurchase_price] = useState('')


    const colorText_BoxProperties = useColorModeValue("gray", "gray.400");
    const colorInput_BoxProperties = useColorModeValue("black", "gray.400");
    const colorBorderInput_BoxProperties = useColorModeValue(
        "gray.300",
        "gray.500"
    );

    const addProperty = () => {
        setDataProperties([
            ...dataProperties,
            { color: "", size: "", quantity: "", purchase_price: "", stock_weight: "", weight_unit: "kg", purchase_date: today, source: "", warehouse: "", receipts: [] },
        ]);
    };

    const removeProperty = (index) => {
        const listProp = [...dataProperties];
        listProp.splice(index, 1);
        setDataProperties(listProp);
    };

    const handleChangeProperty = (e, index) => {
        const { name, value } = e.target;
        const listProp = [...dataProperties];

        if (name === "purchase_price") {
            const formattedValue = handlePriceChange(value);
            if (formattedValue !== null) {
                listProp[index][name] = formattedValue;
                setDataProperties(listProp);
            }
        } else {
            listProp[index][name] = value;
            setDataProperties(listProp);
        }
    };

    const addTotalQntt = () => {
        let totalQntt = 0;
        dataProperties.forEach((item) => {
            // Convertir la quantité en nombre et l'ajouter au total
            totalQntt += parseInt(item.quantity || 0); // Si la quantité est vide, on prend 0
        });
        setTotalQuantity(totalQntt);
    };

    const removeTotlaQntt = (qtt) => {
        if (qtt) {
            setTotalQuantity(totalQuantity - parseInt(qtt));
        }
    };

    const addTotalPrice = () => {
        let totalPrice = 0;
        dataProperties.forEach((item) => {
            // Convertir le prix en nombre et l'ajouter au total
            totalPrice += formatPriceForBackend(item.purchase_price || 0); // Si la quantite est vide, on prend 0
        });
        setTotalPrice(totalPrice.toFixed(2));
    };

    const removeTotlaPrice = (prix) => {
        if (prix) {
            setTotalPrice((parseFloat(totalPrice) - formatPriceForBackend(prix)).toFixed(2));
        }
    };


    const [totalQnttProduct, setTotalQnttProduct] = useState()
    const [totalPriceProduct, setTotalPriceProduct] = useState()
    useEffect(() => {
        axiosClient.get(`/products/${location.state.id}/?business=${currentBusiness.id}`).then(res => {
            setTotalQnttProduct(res.data.total_quantity)
            setTotalPriceProduct(res.data.total_price)
        })
    }, [])


    const isNumeric = (value) => {
        return /^\d+$/.test(value); // Valide les entiers positifs
        // Pour accepter les nombres décimaux, utilisez: /^\d*\.?\d+$/.test(value)
    };

    const UpgradeStockProduct = () => {
        try {

            const hasInvalidNumbers = dataProperties.some(item => {
                return !isNumeric(item.quantity)
            });

            if (hasInvalidNumbers) {
                toast({
                    description: t("Les champs quantité doit contenir uniquement des chiffres"),
                    status: 'error',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                return;
            }

            const hasEmptyRequiredFields = dataProperties.some(item => {
                return !item.quantity || !item.purchase_price;
            });

            if (hasEmptyRequiredFields) {
                toast({
                    description: t("Les champs quantité et prix d'achat sont obligatoires pour toutes les variantes"),
                    status: 'error',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                return;
            }

            const formData = new FormData();
            formData.append("product", location.state.id);
            formData.append("business", currentBusiness.id);
            formData.append("total_quantity", totalQnttProduct + totalQuantity);
            formData.append("total_price", parseFloat(totalPriceProduct) + parseFloat(formatPriceForBackend(totalPrice)));

            // Prepare stock JSON
            const stockData = dataProperties.map(val => {
                return {
                    color: val.color,
                    size: val.size,
                    quantity: val.quantity,
                    purchase_price: val.purchase_price,
                    stock_weight: val.stock_weight,
                    weight_unit: val.weight_unit,
                    purchase_date: val.purchase_date,
                    source: val.source,
                    warehouse: val.warehouse,
                    historique: [
                        {
                            color: val.color,
                            size: val.size,
                            quantity: val.quantity,
                            purchase_price: val.purchase_price,
                            stock_weight: val.stock_weight,
                            weight_unit: val.weight_unit,
                            purchase_date: val.purchase_date,
                            source: val.source,
                            warehouse: val.warehouse,
                            user: user.id,
                            created_at: new Date().toLocaleString()
                        }
                    ]
                };
            });
            formData.append("stock", JSON.stringify(stockData));

            // Append files separately
            dataProperties.forEach((val, index) => {
                if (val.receipts && val.receipts.length > 0) {
                    val.receipts.forEach((file, fileIndex) => {
                        formData.append(`recu_${index}_${fileIndex}`, file);
                    });
                }
            });

            axiosClient.post("/stock/upgrade_stock/", formData)
                .then((response) => {
                    toast({
                        description: t(`Le stock a été mis à niveau avec succès`),
                        status: 'success',
                        duration: 2000,
                        isClosable: true,
                        variant: 'left-accent',
                    });
                    navigate("/My_Stock");
                })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }

    return (
        <Stack>
            <Flex>
                <Box w="90%" pt="12px" mb={8}>

                    <Breadcrumb fontFamily='Plus Jakarta Display' fontStyle={"italic"} fontSize={{ base: "20px", sm: "25px", lg: "27px" }} color="gray">
                        <BreadcrumbItem>
                            <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                        </BreadcrumbItem>

                        <BreadcrumbItem >
                            <BreadcrumbLink onClick={() => navigate('/My_Stock')}>{t("Gestion stock")}</BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink>{t("Mise à niveau du stock")}</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Box>
            </Flex>

            <Flex justify={'center'}>
                <Box
                    bg={useColorModeValue("white", "#212835")}
                    borderWidth="1px"
                    rounded="lg"
                    w={{ base: "100%", lg: "75%" }}
                    shadow="1px 1px 3px rgba(0,0,0,0.3)"
                    p={6}
                    m="10px auto"
                    as="form"
                >
                    <>
                        <Stack
                            mt={3}
                            pt={3}
                            px={{ base: 2, lg: 7 }}
                            bg={useColorModeValue("white", "#212835")}
                            rounded="lg"
                            pb={5}
                        >
                            {/* <Text color={useColorModeValue('gray', 'gray.400')}>Propriétés produit</Text> */}
                            <Heading
                                color={useColorModeValue("gray.500", "gray.400")}
                                w="100%"
                                fontSize={"3xl"}
                                textAlign={"center"}
                                fontWeight="normal"
                                mb={5}
                            >
                                {t("Propriétés produit")}
                            </Heading>
                            {dataProperties.map((val, key) => {
                                return (
                                    <Box key={key} mt={2}>
                                        <Flex gap={5}>
                                            <FormControl id="couleur">
                                                <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                    {t("Couleur")}
                                                </FormLabel>
                                                <Input
                                                    id="couleur"
                                                    name="color"
                                                    type="text"
                                                    color={colorInput_BoxProperties}
                                                    borderColor={colorBorderInput_BoxProperties}
                                                    _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                    placeholder={t("Couleur")}
                                                    value={val.color}
                                                    onChange={(e) => handleChangeProperty(e, key)}
                                                />
                                            </FormControl>
                                            <FormControl id="size">
                                                <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                    {t("Taille")}
                                                </FormLabel>
                                                <Input
                                                    id="size"
                                                    name="size"
                                                    type="text"
                                                    color={colorInput_BoxProperties}
                                                    borderColor={colorBorderInput_BoxProperties}
                                                    _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                    placeholder={t("Taille")}
                                                    value={val.size}
                                                    onChange={(e) => handleChangeProperty(e, key)}
                                                />
                                            </FormControl>
                                        </Flex>
                                        <Flex gap={5} mt={3}>
                                            <FormControl id="quantity" isRequired>
                                                <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                    {t("Quantité")}
                                                </FormLabel>
                                                <Input
                                                    id="quantity"
                                                    name="quantity"
                                                    type="text"
                                                    color={colorInput_BoxProperties}
                                                    borderColor={colorBorderInput_BoxProperties}
                                                    _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                    placeholder={t("Quantité")}
                                                    value={val.quantity}
                                                    onChange={(e) => {
                                                        handleChangeProperty(e, key);
                                                        addTotalQntt();
                                                    }}
                                                />
                                            </FormControl>
                                            <FormControl id="price" isRequired>
                                                <FormLabel color={colorText_BoxProperties} w={"80%"} display={"flex"} alignItems={"center"} gap={1}>
                                                    <Text>{t("Prix d'achat")}</Text> /
                                                    <Text fontSize={12} >{currentBusiness?.currency}</Text>
                                                </FormLabel>
                                                <Input
                                                    id="price"
                                                    name="purchase_price"
                                                    type="text"
                                                    color={colorInput_BoxProperties}
                                                    borderColor={colorBorderInput_BoxProperties}
                                                    _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                    placeholder={t("Prix d'achat")}
                                                    value={val.purchase_price}
                                                    onChange={(e) => {
                                                        handleChangeProperty(e, key);
                                                        addTotalPrice();
                                                    }}
                                                />
                                            </FormControl>
                                        </Flex>
                                        <Flex gap={5} mt={3}>
                                            <FormControl id="stock_weight">
                                                <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                    {t("Poids du stock")}
                                                </FormLabel>
                                                <InputGroup>
                                                    <Input
                                                        id="stock_weight"
                                                        name="stock_weight"
                                                        type="number"
                                                        color={colorInput_BoxProperties}
                                                        borderColor={colorBorderInput_BoxProperties}
                                                        _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                        placeholder={t("Poids")}
                                                        value={val.stock_weight}
                                                        onChange={(e) => handleChangeProperty(e, key)}
                                                    />
                                                    <Select
                                                        name="weight_unit"
                                                        w="120px"
                                                        ml={2}
                                                        value={val.weight_unit}
                                                        onChange={(e) => handleChangeProperty(e, key)}
                                                    >
                                                        <option value="kg">kg</option>
                                                        <option value="g">g</option>
                                                        <option value="lb">lb</option>
                                                        <option value="oz">oz</option>
                                                    </Select>
                                                </InputGroup>
                                            </FormControl>
                                            <FormControl id="source">
                                                <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                    {t("Source")}
                                                </FormLabel>
                                                <Input
                                                    id="source"
                                                    name="source"
                                                    type="text"
                                                    color={colorInput_BoxProperties}
                                                    borderColor={colorBorderInput_BoxProperties}
                                                    _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                    placeholder={t("Source")}
                                                    value={val.source}
                                                    onChange={(e) => handleChangeProperty(e, key)}
                                                />
                                            </FormControl>
                                        </Flex>
                                        <Flex gap={5} mt={3}>
                                            <FormControl id="warehouse">
                                                <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                    {t("Entrepôt / Service")}
                                                </FormLabel>
                                                <Input
                                                    id="warehouse"
                                                    name="warehouse"
                                                    type="text"
                                                    color={colorInput_BoxProperties}
                                                    borderColor={colorBorderInput_BoxProperties}
                                                    _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                    placeholder={t("Entrepôt / Service")}
                                                    value={val.warehouse}
                                                    onChange={(e) => handleChangeProperty(e, key)}
                                                />
                                            </FormControl>
                                            <FormControl id="purchase_date" isRequired>
                                                <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                    {t("Date d'achat")}
                                                </FormLabel>
                                                <Input
                                                    id="purchase_date"
                                                    name="purchase_date"
                                                    type="date"
                                                    max={today}
                                                    color={colorInput_BoxProperties}
                                                    borderColor={colorBorderInput_BoxProperties}
                                                    _focus={{ boxShadow: "none", borderColor: "gray" }}
                                                    value={val.purchase_date}
                                                    onChange={(e) => handleChangeProperty(e, key)}
                                                />
                                            </FormControl>
                                        </Flex>
                                        <Flex gap={5} mt={3}>
                                            <FormControl id="recu">
                                                <FormLabel color={colorText_BoxProperties} w={"80%"}>
                                                    {t("Reçu (Fichier)")}
                                                </FormLabel>
                                                <Box
                                                    border="2px dashed"
                                                    borderColor="gray.200"
                                                    p={4}
                                                    rounded="xl"
                                                    textAlign="center"
                                                    cursor="pointer"
                                                    _hover={{ borderColor: 'purple.400', bg: 'purple.50' }}
                                                    position="relative"
                                                >
                                                    <Input
                                                        id="receipts"
                                                        name="receipts"
                                                        type="file"
                                                        multiple
                                                        accept="image/*,.pdf"
                                                        opacity={0}
                                                        position="absolute"
                                                        top={0}
                                                        left={0}
                                                        w="100%"
                                                        h="100%"
                                                        cursor="pointer"
                                                        onChange={async (e) => {
                                                            const files = Array.from(e.target.files);
                                                            const validFiles = [];
                                                            const extensions = ['.png', '.jpg', '.jpeg', '.webp', '.pdf'];
                                                            
                                                            if (dataProperties[key].receipts.length + files.length > 5) {
                                                                toast({ description: t("Max 5 fichiers"), status: 'warning' });
                                                                return;
                                                            }

                                                            for (const file of files) {
                                                                const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
                                                                if (!extensions.includes(ext)) {
                                                                    toast({ description: `${file.name}: ${t("Format non supporté")}`, status: 'error' });
                                                                    continue;
                                                                }
                                                                if (file.name.length > 50) {
                                                                    toast({ description: `${file.name}: ${t("Nom trop long (max 50)")}`, status: 'error' });
                                                                    continue;
                                                                }
                                                                if (file.size > 4 * 1024 * 1024) {
                                                                    toast({ description: `${file.name}: ${t("Fichier trop volumineux (max 4Mo)")}`, status: 'error' });
                                                                    continue;
                                                                }

                                                                if (file.type.startsWith('image/')) {
                                                                    const resized = await new Promise((resolve) => {
                                                                        Resizer.imageFileResizer(
                                                                            file, 800, 800, 'JPEG', 80, 0,
                                                                            (uri) => resolve(uri), 'file'
                                                                        );
                                                                    });
                                                                    validFiles.push(resized);
                                                                } else {
                                                                    validFiles.push(file);
                                                                }
                                                            }
                                                            const listProp = [...dataProperties];
                                                            listProp[key]['receipts'] = [...listProp[key]['receipts'], ...validFiles];
                                                            setDataProperties(listProp);
                                                        }}
                                                    />
                                                    <AttachmentIcon color="gray.400" mb={2} />
                                                    <Text fontSize="sm" color="gray.500">
                                                        {val.receipts.length > 0 ? `${val.receipts.length} ${t("fichiers sélectionnés")}` : t("Cliquez ou glissez des fichiers ici")}
                                                    </Text>
                                                </Box>
                                                <Flex wrap="wrap" gap={2} mt={2}>
                                                    {val.receipts.map((f, i) => (
                                                        <Badge key={i} colorScheme="purple" p={1} px={2} rounded="md" display="flex" alignItems="center">
                                                            <a href={URL.createObjectURL(f)} target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                                <AttachmentIcon mr={1} fontSize="10px" />
                                                                {f.name.substring(0, 10)}...
                                                            </a>
                                                            <IconButton size="xs" ml={2} icon={<CloseIcon />} variant="ghost" _hover={{ bg: 'red.100', color: 'red.500' }} onClick={() => {
                                                                const listProp = [...dataProperties];
                                                                listProp[key]['receipts'] = listProp[key]['receipts'].filter((_, idx) => idx !== i);
                                                                setDataProperties(listProp);
                                                            }} />
                                                        </Badge>
                                                    ))}
                                                </Flex>
                                            </FormControl>
                                        </Flex>

                                        <Flex justifyContent={"end"} mt={3} gap={3}>
                                            <Flex justifyContent={"end"} gap={3}>
                                                {dataProperties.length > 1 && (
                                                    <Button
                                                        colorScheme="red"
                                                        size={"sm"}
                                                        variant={"outline"}
                                                        onClick={() => {
                                                            removeProperty(key);
                                                            removeTotlaQntt(val.quantity);
                                                            removeTotlaPrice(val.price);
                                                        }}
                                                    >
                                                        {t("Supprimer")}
                                                    </Button>
                                                )}
                                                {dataProperties.length - 1 === key && (
                                                    <Button
                                                        colorScheme="green"
                                                        size={"sm"}
                                                        variant={"outline"}
                                                        onClick={() => {
                                                            addProperty();
                                                        }}
                                                    >
                                                        Plus
                                                    </Button>
                                                )}
                                            </Flex>
                                        </Flex>
                                    </Box>
                                );
                            })}
                        </Stack>

                        <Stack
                            mt={3}
                            pt={3}
                            px={7}
                            bg={useColorModeValue("gray.50", "#212835")}
                            rounded="lg"
                            pb={5}
                        >
                            <Text color={useColorModeValue("gray", "gray.400")}>Total</Text>
                            <Flex justifyContent={"space-between"}>
                                <Flex mt={2} gap={2}>
                                    <Text
                                        textTransform={"uppercase"}
                                        color={useColorModeValue("gray", "gray.400")}
                                    >
                                        {t("Quantité")} :{" "}
                                    </Text>
                                    <Text color={useColorModeValue("gray", "gray.200")}>
                                        {totalQuantity}
                                    </Text>
                                </Flex>
                                <Flex mt={2} gap={2} alignItems="center">

                                    <Flex gap={1} alignItems="center">
                                        <Text
                                            textTransform={"uppercase"}
                                            color={useColorModeValue("gray", "gray.400")}
                                        >
                                            {t("Prix")} /
                                        </Text>
                                        <Text fontSize={12} >{currentBusiness?.currency}</Text>:
                                    </Flex>
                                    <Input
                                        id="totalPrice"
                                        name="totalPrice"
                                        type="text"
                                        color={useColorModeValue("gray", "gray.200")}
                                        borderColor={colorBorderInput_BoxProperties}
                                        _focus={{ boxShadow: "none", borderColor: "gray" }}
                                        placeholder={t("Prix total")}
                                        value={totalPrice}
                                        onChange={(e) => {
                                            const formattedValue = handlePriceChange(e.target.value);
                                            if (formattedValue !== null) {
                                                setTotalPrice(formattedValue);
                                            }
                                        }}
                                        w="120px"
                                        size="sm"
                                    />
                                </Flex>
                            </Flex>
                        </Stack>
                    </>
                </Box>
            </Flex>

            <Flex
                justify={'center'}>
                <Flex w={{ base: '100%', lg: '75%' }} justify={"end"}>
                    <Button
                        w="7rem"
                        colorScheme="purple"
                        size={"md"}
                        variant={"outline"}
                        onClick={UpgradeStockProduct}
                    >
                        {t("Ajouter")}
                    </Button>
                </Flex>
            </Flex>

        </Stack>
    )
}

export default UpgradeStock